import { PROJECT_BASE_DIR } from '@/features/project/review-sheet/utils/constants';
import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router';

export const useNavigateToWorkflowProject = () => {
  const navigate = useNavigate();
  return useCallback(
    async ({
      projectId,
      newTab = false,
    }: {
      projectId: string;
      newTab?: boolean;
    }) => {
      const path = generatePath(`${PROJECT_BASE_DIR}/:projectId`, {
        projectId,
      });

      if (newTab) {
        window.open(path, '_blank');
      } else {
        navigate(path);
      }
    },
    [navigate],
  );
};
